import { Observable, Subject } from 'rxjs';

import { Injectable } from '@angular/core';

import { FsLprFleetRead } from '../api/models';

@Injectable({
  providedIn: 'root',
})
export class PlateImageDownloadService {
  public get getCroppedImage$(): Observable<string> {
    return this._getCroppedImage$.asObservable();
  }

  private _getCroppedImage$: Subject<string> = new Subject<string>();

  constructor() {}

  public async downloadImage(plate: FsLprFleetRead, croppedImageUrl: string): Promise<void> {
    try {
      if (croppedImageUrl) {
        await this._downloadImageFromUrl(croppedImageUrl, `${plate.plate}_cropped.jpg`);
      }
      if (plate.contextImageUrl) {
        await this._downloadImageFromUrl(plate.contextImageUrl, `${plate.plate}_full.jpg`);
      }
    } catch (error) {
      console.error('Error downloading images:', error);
    }
  }

  /**
   * Helper method to download an image from a URL
   * @param imageUrl The URL of the image to download
   * @param filename The filename to use for the downloaded image
   */
  private async _downloadImageFromUrl(imageUrl: string, filename: string): Promise<void> {
    try {
      // Fetch the image as a blob
      const response = await fetch(imageUrl);
      const blob = await response.blob();

      // Create object URL from blob
      const blobUrl = window.URL.createObjectURL(blob);

      // Create download link
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      // Known to run into CORS issues for some images (e.g. Fusus provider images from AWS)
      // open the image in a new tab
      window.open(imageUrl, '_blank').focus();
    }
  }

  public async downloadPlate(plate: FsLprFleetRead): Promise<void> {
    if (plate.plateImageUrl) {
      try {
        // Fetch the image as a blob
        const response = await fetch(plate.plateImageUrl, { mode: 'cors', cache: 'no-cache' });
        const blob = await response.blob();

        // Create object URL from blob
        const blobUrl = window.URL.createObjectURL(blob);

        // Create download link
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = `plate_${plate.plate}.jpg`;
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        // Known to run into CORS issues for some images (e.g. Fusus provider images from AWS)
        // open the image in a new tab
        window.open(plate.plateImageUrl, '_blank').focus();
      }
    }
  }
}
